import React from 'react';

import { CATEGORIES } from 'modules/activities-management';
import switchControl from './Controls';

export const Activity = ({
  activity,
  geojsonConflicts,
  data,
  activityTypes,
  activityProps,
}) => (
  <React.Fragment>
    <p><strong>Type d&apos;activité</strong></p>
    <p>{`${activityProps.label} / ${CATEGORIES[activityProps.category]}`}</p>
    {switchControl(activity, geojsonConflicts, data, activityTypes)}
  </React.Fragment>
);

export default Activity;



// WEBPACK FOOTER //
// ./src/components/Summary/Activity.js